var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from 'react-router-dom';
import { FirebaseAuth } from '../FirebaseAuth/firebase';
import { userSignIn } from '../../libs/user';
import { captureRedirect, consumeRedirect } from '../../libs/redirect';
import Alert from '../Alert';
import Loader from '../Loader';
import { authErrorMessage } from '../../libs/authErrors';
import CredentialsStep from './CredentialsStep';
import ResetStep from './ResetStep';
import TotpStep from './TotpStep';
import LinkStep from './LinkStep';
import { signInWithPassword, createEmailAccount, signInWithGoogle, signInWithMicrosoft, sendReset, resolveTotp, linkPendingCredential, isTotpHint } from './auth';
var SignInPanel = function (_a) {
    var _b = _a.mode, initialMode = _b === void 0 ? 'signin' : _b, onSignInSuccess = _a.onSignInSuccess, onSignInStart = _a.onSignInStart;
    var _c = useState(initialMode), mode = _c[0], setMode = _c[1];
    var _d = useState('credentials'), step = _d[0], setStep = _d[1];
    var _e = useState(false), busy = _e[0], setBusy = _e[1];
    var _f = useState(null), banner = _f[0], setBanner = _f[1];
    var _g = useState(''), email = _g[0], setEmail = _g[1];
    var _h = useState(''), password = _h[0], setPassword = _h[1];
    var _j = useState(''), fullName = _j[0], setFullName = _j[1];
    var _k = useState(''), code = _k[0], setCode = _k[1];
    var _l = useState([]), hints = _l[0], setHints = _l[1];
    var _m = useState(null), hintUid = _m[0], setHintUid = _m[1];
    // The resolver is a live object holding server state; state would invite a
    // dependency comparison that tears it. Same for the pending credential.
    var resolverRef = useRef(null);
    var pendingCredRef = useRef(null);
    var pendingEmailRef = useRef(null);
    var onSuccessRef = useRef(onSignInSuccess);
    var onStartRef = useRef(onSignInStart);
    useEffect(function () { onSuccessRef.current = onSignInSuccess; }, [onSignInSuccess]);
    useEffect(function () { onStartRef.current = onSignInStart; }, [onSignInStart]);
    // Only capture ?re= when this panel owns navigation. Write-only and idempotent,
    // so StrictMode's double-mount is harmless.
    useEffect(function () {
        if (!onSuccessRef.current) {
            captureRedirect();
        }
    }, []);
    /** Every successful branch ends here — password, OAuth, and post-TOTP alike. */
    var finish = useCallback(function (authResult) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!pendingCredRef.current) return [3 /*break*/, 2];
                    // Link before userSignIn, so the users/{uid} write sees the final profile.
                    return [4 /*yield*/, linkPendingCredential(pendingCredRef.current)];
                case 1:
                    // Link before userSignIn, so the users/{uid} write sees the final profile.
                    _a.sent();
                    pendingCredRef.current = null;
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4:
                    // userSignIn silently never invokes its callback when currentUser is null,
                    // which would leave the panel spinning forever. Check first.
                    if (FirebaseAuth.auth().currentUser === null) {
                        setStep('fatal');
                        return [2 /*return*/];
                    }
                    if (onStartRef.current) {
                        onStartRef.current();
                    }
                    setStep('finalizing');
                    userSignIn(function (ok) {
                        if (!ok) {
                            setStep('fatal');
                            return;
                        }
                        if (onSuccessRef.current) {
                            onSuccessRef.current(authResult);
                            return;
                        }
                        window.location.assign(consumeRedirect());
                    });
                    return [2 /*return*/];
            }
        });
    }); }, []);
    /** Every failing branch ends here. */
    var handleAuthError = useCallback(function (err) {
        var _a, _b;
        setBusy(false);
        if ((err === null || err === void 0 ? void 0 : err.code) === 'auth/multi-factor-auth-required') {
            var resolver = err.resolver;
            resolverRef.current = resolver;
            setHints(resolver.hints);
            setCode('');
            var usable = resolver.hints.filter(isTotpHint);
            if (usable.length === 1) {
                setHintUid(usable[0].uid);
                setStep('totp');
            }
            else if (usable.length > 1) {
                setHintUid(usable[0].uid);
                setStep('totp');
            }
            else {
                // Enrolled, but with nothing this app can challenge.
                setStep('totp');
            }
            return;
        }
        if ((err === null || err === void 0 ? void 0 : err.code) === 'auth/account-exists-with-different-credential') {
            pendingCredRef.current = (_a = err.credential) !== null && _a !== void 0 ? _a : null;
            pendingEmailRef.current = (_b = err.email) !== null && _b !== void 0 ? _b : null;
            if (err.email) {
                setEmail(err.email);
            }
            setPassword('');
            setStep('link');
            return;
        }
        if ((err === null || err === void 0 ? void 0 : err.code) === 'auth/invalid-multi-factor-session' ||
            (err === null || err === void 0 ? void 0 : err.code) === 'auth/missing-multi-factor-session') {
            // Must clear, or every retry reuses a dead resolver and the visitor is
            // stuck in a loop with no way out but a reload.
            resolverRef.current = null;
            setHints([]);
            setHintUid(null);
            setCode('');
            setStep('credentials');
        }
        var message = authErrorMessage(err === null || err === void 0 ? void 0 : err.code);
        if (message) {
            setBanner(message);
        }
    }, []);
    /** Wraps any auth call with the shared busy/banner/error handling. */
    var attempt = useCallback(function (fn) { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBusy(true);
                    setBanner(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fn()];
                case 2:
                    result = _a.sent();
                    return [4 /*yield*/, finish(result)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    handleAuthError(err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [finish, handleAuthError]);
    var submitCredentials = function () { return attempt(function () {
        return mode === 'signup'
            ? createEmailAccount(email.trim(), password, fullName)
            : signInWithPassword(email.trim(), password);
    }); };
    var submitTotp = function () {
        var resolver = resolverRef.current;
        if (!resolver || !hintUid) {
            setBanner('Your sign-in attempt expired. Please start again.');
            setStep('credentials');
            return;
        }
        return attempt(function () { return resolveTotp(resolver, hintUid, code); });
    };
    var submitReset = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBusy(true);
                    setBanner(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendReset(email.trim())];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    // Never reveal whether the address exists. Only surface problems the
                    // visitor can act on, like a malformed address or being rate-limited.
                    if ((err_2 === null || err_2 === void 0 ? void 0 : err_2.code) === 'auth/invalid-email' || (err_2 === null || err_2 === void 0 ? void 0 : err_2.code) === 'auth/too-many-requests') {
                        setBusy(false);
                        setBanner(authErrorMessage(err_2.code));
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 4:
                    setBusy(false);
                    setStep('reset-sent');
                    return [2 /*return*/];
            }
        });
    }); };
    var backToCredentials = function () {
        resolverRef.current = null;
        pendingCredRef.current = null;
        setHints([]);
        setHintUid(null);
        setCode('');
        setPassword('');
        setBanner(null);
        setStep('credentials');
    };
    if (step === 'finalizing') {
        return _jsx(Loader, { text: "Signing you in..." });
    }
    if (step === 'fatal') {
        return (_jsxs("div", { className: "text-center", children: [_jsx("img", { width: "100", src: "/logo.svg", alt: "LTIAAS logo" }), _jsx("h1", { children: "Something went wrong" }), _jsx("p", { children: "We couldn't finish signing you in. Please try again." }), _jsx(Link, { to: "/", children: "Home" })] }));
    }
    return (_jsxs(_Fragment, { children: [banner !== null &&
                _jsx(Alert, { type: "danger", message: banner, dismissible: true, onDismiss: function () { return setBanner(null); } }), (step === 'credentials') &&
                _jsx(CredentialsStep, { mode: mode, busy: busy, email: email, password: password, fullName: fullName, onEmail: setEmail, onPassword: setPassword, onFullName: setFullName, onSubmit: submitCredentials, onGoogle: function () { return attempt(signInWithGoogle); }, onMicrosoft: function () { return attempt(signInWithMicrosoft); }, onForgot: function () { setBanner(null); setStep('reset'); }, onSwitchMode: function () { setBanner(null); setMode(mode === 'signup' ? 'signin' : 'signup'); } }), (step === 'reset' || step === 'reset-sent') &&
                _jsx(ResetStep, { sent: step === 'reset-sent', busy: busy, email: email, onEmail: setEmail, onSubmit: submitReset, onBack: backToCredentials }), step === 'totp' &&
                _jsx(TotpStep, { busy: busy, code: code, onCode: setCode, onSubmit: submitTotp, onCancel: backToCredentials, hints: hints, hintUid: hintUid, onHint: setHintUid, accountEmail: pendingEmailRef.current || email || null }), step === 'link' &&
                _jsx(LinkStep, { busy: busy, email: pendingEmailRef.current, password: password, onPassword: setPassword, onSubmitPassword: function () { return attempt(function () {
                        return signInWithPassword((pendingEmailRef.current || email).trim(), password);
                    }); }, onGoogle: function () { return attempt(signInWithGoogle); }, onMicrosoft: function () { return attempt(signInWithMicrosoft); }, onCancel: backToCredentials })] }));
};
export default SignInPanel;
